<template>
    <div :id="this.id"></div>
</template>

<script>
    import { mixin } from './../../mixins'

    export default {
        mixins: [
            mixin
        ]        
    }
</script>



// WEBPACK FOOTER //
// src/components/vue2-frappe/components/Charts/Chart.vue